/*
    Add here your own custom javascript ​‍‌‍‍‍​‌‍⁠​‌​‌‍​‌‌‌‍​​​‌‍​​‌​‍​​‌‌‍​‌​‌‍​‌​​‍‌​​​‍​‌‌​‍‌​​‌‍​​‌‌‍​​‌‌‍​​​​﻿‌‌‌‌​‍‍‍‌‌‌‍​​​
*/

// Fix for the RTL language in the demo
document.querySelectorAll('[href="/ar"]').forEach(link => {
    link.setAttribute('target', '_blank')
})

function renderWishlistCounter(swat) {
	var counter_elem = document.querySelectorAll(".wishlist-count-badge"); /* Targets the span added in Step 1. */
	if (counter_elem) {
		for (var i = 0; i < counter_elem.length; i++) {
			if (swat.renderWishlistCount) {
				swat.renderWishlistCount(counter_elem[i], function(count, element) {
                    //if count is not 0 then add class show-badge and remove hidden attribute elese add hidden attribute and remove show-badge class
                    if (count !== 0) {
                        element.classList.add('show-badge');
                        element.removeAttribute('hidden');
                    } else {
                        element.classList.remove('show-badge');
                        element.setAttribute('hidden', 'hidden');
                    }
					console.log("debug - renderWishlistCount", count, element); 
				});
			}
		}
	}
}

if (!window.SwymCallbacks) {
	window.SwymCallbacks = [];
}

window.SwymCallbacks.push(renderWishlistCounter);

/*
  Custom rug sizes (ported from the old rugsdoneright theme).
  A "custom size" variant's unit price is the price PER square foot (type 2)
  or PER linear foot (type 1). When such an option is selected, dimension
  inputs appear; on add-to-cart the cart quantity is set to
  Math.round(width × length) (or the linear feet), so Shopify charges
  quantity × unit price. See product.js onSubmitAtcForm for the ATC hook.
*/
;(function () {
  function money(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents)
    }
    return '$' + (cents / 100).toFixed(2)
  }

  function getForm(el) {
    return el.closest('form[onsubmit*="onSubmitAtcForm"]') || el.closest('form')
  }

  function selectedOptionValues(form) {
    var values = []
    form.querySelectorAll('.product-option').forEach(function (el) {
      if (el.type === 'radio') {
        if (el.checked) values.push(el.value)
      } else {
        values.push(el.value)
      }
    })
    return values
  }

  function customValues(container) {
    return (container.getAttribute('data-custom-size-values') || '')
      .split('||')
      .map(function (s) { return s.trim() })
      .filter(Boolean)
  }

  function isCustomActive(form) {
    var container = form.querySelector('.js-custom-size')
    if (!container) return false
    var list = customValues(container)
    return selectedOptionValues(form).some(function (v) { return list.indexOf(v) !== -1 })
  }

  function selectedVariant(form) {
    try {
      var variants = JSON.parse(form.getAttribute('data-variants') || '[]')
      var idInput = form.querySelector('[name="id"]')
      if (!idInput) return null
      return variants.filter(function (v) { return String(v.id) === String(idInput.value) })[0] || null
    } catch (e) {
      return null
    }
  }

  function computeQuantity(container) {
    var type = container.getAttribute('data-custom-size-type')
    var inputs = container.querySelectorAll('.js-custom-size-dimension')
    if (type === '2' && inputs.length >= 2) {
      var w = parseFloat(inputs[0].value)
      var l = parseFloat(inputs[1].value)
      if (!(w > 0) || !(l > 0)) return null
      return Math.round(w * l)
    } else if (inputs.length >= 1) {
      var f = parseInt(inputs[0].value, 10)
      if (!(f > 0)) return null
      return f
    }
    return null
  }

  function setInputsDisabled(container, disabled) {
    container.querySelectorAll('.js-custom-size-input, .js-custom-size-dimension').forEach(function (el) {
      el.disabled = disabled
    })
  }

  function update(form) {
    var container = form.querySelector('.js-custom-size')
    if (!container) return

    var active = isCustomActive(form)
    container.classList.toggle('d-none', !active)
    setInputsDisabled(container, !active)

    // Hide the normal quantity stepper while a custom size is active.
    var qtyWrapper = form.querySelector('.quantity-wrapper')
    if (qtyWrapper) qtyWrapper.classList.toggle('d-none', active)

    var totalEl = container.querySelector('.custom-size-total')
    if (!active) {
      if (totalEl) totalEl.innerHTML = ''
      return
    }

    var qty = computeQuantity(container)
    var variant = selectedVariant(form)
    var unit = container.getAttribute('data-custom-size-type') === '2' ? 'sq ft' : 'ft'

    if (qty && variant) {
      var total = qty * variant.price
      totalEl.innerHTML =
        '<strong>Total: ' + money(total) + '</strong> ' +
        '<span class="text-muted">(' + qty.toLocaleString() + ' ' + unit + ' × ' + money(variant.price) + '/' + unit + ')</span>'
    } else {
      totalEl.innerHTML = '<span class="text-muted">Enter your size to see the price.</span>'
    }
  }

  // Consumed by product.js onSubmitAtcForm to override the cart quantity.
  window.customRugSize = {
    isActive: isCustomActive,
    getQuantity: function (form) {
      var container = form.querySelector('.js-custom-size')
      return container ? computeQuantity(container) : null
    }
  }

  document.addEventListener('change', function (e) {
    var t = e.target
    if (t && t.classList && t.classList.contains('product-option')) {
      var form = getForm(t)
      // Let product.js update [name="id"] first, then recompute.
      if (form) setTimeout(function () { update(form) }, 0)
    }
  })

  document.addEventListener('input', function (e) {
    var t = e.target
    if (t && t.classList && t.classList.contains('js-custom-size-dimension')) {
      var form = getForm(t)
      if (form) update(form)
    }
  })

  function initAll() {
    document.querySelectorAll('form[onsubmit*="onSubmitAtcForm"]').forEach(update)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll)
  } else {
    initAll()
  }
})();